import React from 'react';

const SVG = ({ style = {}, colors, width = '100%', viewBox = '0 0 400 400' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <circle cx="200" cy="200" r="200" fill={colors.light} />
      <path d="M0,200 A 400 450 0 0 0 400 200 A 10 10 0 0 1 0 200" fill={colors.dark} />
    </g>
  </svg>
);

export default SVG;
